import { useEffect } from "react";

export const useDisableInspect = () => {
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const handleKeyDown = (e) => {
      if (e.keyCode === 123) {
        e.preventDefault();
      }

      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
      }
      // Command + Option + I (Mac)
      if ((e.ctrlKey || e.metaKey) && e.altKey && e.keyCode === 73) {
        e.preventDefault();
      }

      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
      }

      // Command + Option + J (Mac Console)
      if ((e.ctrlKey || e.metaKey) && e.altKey && e.keyCode === 74) {
        e.preventDefault();
      }

      if ((e.ctrlKey || e.metaKey) && e.keyCode === 85) {
        e.preventDefault();
      }

      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
      }

      // Command + Option + C (Mac Inspect)
      if ((e.ctrlKey || e.metaKey) && e.altKey && e.keyCode === 67) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};
